import Movement from "./movement";

export default class Pass extends Movement {
  render = function () {
    this.setupContext();

    this.context.strokeStyle = "rgba(255, 255, 255, 1)";
    this.context.fillStyle = "rgba(255, 255, 255, 1)";

    this.renderMovement();
    this.renderArrow();

    this.resetContext();
  }
}



